import {useFetch} from "../useFetch";
import {TypeContainer} from "../../types/api/guide/typeСontainer.types";
import {typeContainerService} from "../../services/guide/typeContainer-service";

export const useFetchAllTypeContainer = () => {
    const { isLoading, error, data, refetch } = useFetch<TypeContainer[]>(typeContainerService.getAll);

    return { data: data || [], isLoading, error, refetch };
}
